"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ShapeElement_1 = require("./ShapeElement");
var AnimationValue_1 = require("../properties/AnimationValue");
var AnimationMultidimensional_1 = require("../helpers/AnimationMultidimensional");
var Fill = (function (_super) {
    tslib_1.__extends(Fill, _super);
    function Fill(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.opacity = new AnimationValue_1.AnimationValue(_this._rawData.o, version);
        _this.color = new AnimationMultidimensional_1.AnimationMultidimensional(_this._rawData.c, version);
        return _this;
    }
    return Fill;
}(ShapeElement_1.ShapeElement));
exports.Fill = Fill;
//# sourceMappingURL=Fill.js.map